import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../shared/breadcrumbs/Breadcrumbs';
import '../Technical.css';

class CompetitionAPI extends Component {
    render() {
        return (
            <div className="technical-main">
                <Breadcrumbs />
                <div className="technical-content">
                    <h1 className="main-heading">
                        Competition API
                </h1>
                    <h2 className="main-subheading">
                        Methods</h2>
                    <ul>
                        <li className="technical-list-item"><Link to="/technical/competitionapi/addvote">allaboutme.pcs.add_vote</Link></li>
                        <li className="technical-list-item"><Link to="/technical/competitionapi/echo">allaboutme.pcs.echo</Link></li>
                        <li className="technical-list-item"><Link to="/technical/competitionapi/getcaptcha">allaboutme.pcs.get_captcha</Link></li>
                        <li className="technical-list-item"><Link to="/technical/competitionapi/getdesign">allaboutme.pcs.get_design</Link></li>
                        <li className="technical-list-item"><Link to="/technical/competitionapi/getdesigncount">allaboutme.pcs.get_design_count</Link></li>
                        <li className="technical-list-item"><Link to="/technical/competitionapi/getdesignlist">allaboutme.pcs.get_design_list</Link></li>
                        <li className="technical-list-item"><Link to="/technical/competitionapi/gettopvoted">allaboutme.pcs.get_top_voted</Link></li>
                        <li className="technical-list-item"><Link to="/technical/competitionapi/setpublicdesign">allaboutme.pcs.set_public_design</Link></li>
                    </ul>
                    <br />
                    <div className="technical-main-content">
                        <div>
                            <h3>
                                Request Format</h3>
                            <p>
                                To call a certain method, just make an HTTP GET request to the following URL:</p>
                            <pre>
                                [base-url]/RestAPI.ashx
                            </pre>
                            <p>
                                The <em>base-url</em> will be assigned by Thales and will be different for each
                            environment (development, testing and production). For example, if the <em>base-url</em>
                                is <em>http://development.example.com</em>, use this URL to call the <Link to="/technical/competitionapi/echo">
                                    allaboutme.pcs.echo</Link> method:</p>
                            <pre>
                                http://development.example.com/RestAPI.ashx?method=allaboutme.pcs.echo
                            </pre>
                            <br />
                        </div>
                        <div>
                            <h3>
                                Response Format</h3>
                            <p>
                                The response to any method call is always a simple XML block. If the method was
                                successful, the response will have the following format. The XML payload will depend
                            on the specific method being called.</p>
                            <pre>
                                &lt;?xml version=&quot;1.0&quot; encoding=&quot;utf-8&quot; ?&gt;
                                &lt;rsp stat=&quot;ok&quot;&gt;
                                    [xml-payload-here]
                                &lt;/rsp&gt;
                            </pre>
                            <p>
                                If the method fails for any reason, the response will be:</p>
                            <pre>
                                &lt;?xml version=&quot;1.0&quot; encoding=&quot;utf-8&quot; ?&gt;
                                &lt;rsp stat=&quot;fail&quot;&gt;
                                    &lt;err code=&quot;[error-code]&quot; msg=&quot;[error-message]&quot; /&gt;
                                &lt;/rsp&gt;
                            </pre>
                            <br />
                        </div>
                        <div>
                            <h3>
                                Designs</h3>
                            <p>
                                The designs referenced by the Competition API are publicly avaliable in the following
                            sizes and layouts:</p>
                            <ul>
                                <li>241 x 153 pixels with template
                                <pre>
                                        [base-url]/GetPublicDesign.ashx?provider=pcs&amp;card_image_id=[card-image-id]
                                </pre>
                                </li>
                                <li>2025 x 1275 pixels with template
                                <pre>
                                        [base-url]/GetPublicDesign.ashx?provider=pcs&amp;design_type=designwithtemplate
                                                                        &amp;card_image_id=[card-image-id]
                                </pre>
                                </li>
                                <li>2025 x 1275 pixels without template
                                <pre>
                                        [base-url]/GetPublicDesign.ashx?provider=pcs&amp;design_type=design&amp;card_image_id=[card-image-id]
                                </pre>
                                </li>
                            </ul>
                            <br />
                        </div>
                        <div>
                            <h3>
                                Templates</h3>
                            <p>
                                Templates are image files containing the card elements (apart from the design submitted
                                by the user) against a transparent background. By overlaying the correct templates
                                on a design without a template you can obtain the same result as the design with
                                the template. Providing the elements separately gives more flexibility to the competition
                            site creators.</p>
                            <p>
                                The templates that can be overlaid on the cards are available from the following
                            URLs:</p>
                            <ul>
                                <li>Template (2025 x 1275 pixels)
                                <pre>
                                        [base-url]/GetPublicTemplate.ashx?provider=pcs&amp;handover_key=[handover-key]
                                </pre>
                                </li>
                            </ul>
                            <br />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default CompetitionAPI;